import { render, staticRenderFns } from "./CardHistoricoStatus.vue?vue&type=template&id=71747e9c&scoped=true"
import script from "./CardHistoricoStatus.vue?vue&type=script&lang=js"
export * from "./CardHistoricoStatus.vue?vue&type=script&lang=js"
import style0 from "./CardHistoricoStatus.vue?vue&type=style&index=0&id=71747e9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71747e9c",
  null
  
)

export default component.exports